import { Droplets, Truck, Store, Sparkles, Package } from "lucide-react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs";
import { useLanguage } from "@/context/LanguageContext";
import { ProductCard } from "@/components/flower/ProductCard";

// Products Section Component
export const ProductsSection = ({ productos }) => {
  const { t } = useLanguage();
  if (!productos) return null;

  const stages = [
    { key: 'hidratacion', label: t.hydration, icon: Droplets, color: '#3B82F6' },
    { key: 'almacenamiento_transporte', label: t.storage, icon: Truck, color: '#8B5CF6' },
    { key: 'distribucion', label: t.distribution, icon: Store, color: '#F59E0B' },
    { key: 'acabados_finales', label: t.finishing, icon: Sparkles, color: '#EC4899' }
  ];

  return (
    <div className="mt-4">
      <div className="flex items-center gap-2 mb-3">
        <Package className="w-4 h-4" style={{ color: '#1A3C34' }} />
        <h5 className="font-heading text-sm font-semibold" style={{ color: '#1A3C34' }}>
          {t.floraLifeRecommended}
        </h5>
      </div>

      <Tabs defaultValue="hidratacion" className="w-full">
        <TabsList className="w-full flex flex-wrap h-auto gap-1 bg-transparent p-0 mb-3">
          {stages.map(stage => {
            const hasProducts = productos[stage.key]?.length > 0;
            if (!hasProducts) return null;
            return (
              <TabsTrigger
                key={stage.key}
                value={stage.key}
                className="flex items-center gap-1 px-3 py-1.5 text-xs rounded-full data-[state=active]:bg-primary data-[state=active]:text-primary-foreground transition-all"
                style={{
                  backgroundColor: 'rgba(163, 177, 138, 0.1)',
                  color: '#1A3C34'
                }}
                data-testid={`tab-${stage.key}`}
              >
                <stage.icon className="w-3 h-3" />
                {stage.label}
              </TabsTrigger>
            );
          })}
        </TabsList>

        {stages.map(stage => (
          <TabsContent key={stage.key} value={stage.key} className="mt-0">
            <div className="space-y-2">
              {productos[stage.key]?.map((product) => (
                <ProductCard key={product.nombre} product={product} />
              ))}
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};
